import {component, EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class TableDefinitionDiscount extends EntityData<TableDefinitionDiscount> {
    @field discountId: number;
}

export class TableDefinitionData extends EntityData<TableDefinitionData> {
    @identifier tableDefinitionId: string;
    @field outletGroupId: number;
    @field name: string;
    @field serviceArea: number;
    @field code: string = null;
    @field spendLimit: number;
    @field capacity: number;
    @component discount: TableDefinitionDiscount = null;
}
